var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-mail--page"},[_c('base-form',{staticClass:"template-mail position--relative"},[_c('base-card',{staticClass:"template-mail__content",attrs:{"add-margins":false},scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('div',{staticClass:"template-mail__header"},[_c('base-field',{staticClass:"template-mail__name",attrs:{"settings":{
                            label: { class: (_vm.generateLabelClass + " template-mail__label"), text: _vm.$t('global.templateName') },
                            input: {
                                component: 'InputBasic',
                                id: 'name',
                                name: 'name',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.name,
                                placeholder: _vm.$t('global.templateName'),
                                browserAutocomplete: 'name',
                                isRequired: false,
                                isMissing: _vm.errors.missing.name,
                                noListener: true
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}})],1)]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"template-mail__body"},[_c('base-field',{staticClass:"template-mail__subject",attrs:{"settings":{
                            label: { class: 'template-mail__label capitalize', text: _vm.$t('global.subject') },
                            input: {
                                component: 'InputBasic',
                                id: 'subject',
                                name: 'subject',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.subject,
                                placeholder: _vm.$t('global.emailSubject'),
                                browserAutocomplete: 'name',
                                isRequired: false,
                                isMissing: _vm.errors.missing.subject,
                                noListener: true
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"template-mail__attachments",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.attachments')  },
                            input: {
                                component: 'InputFileDefault',
                                id: 'attachments',
                                name: 'attachments',
                                type: 'file',
                                value: '',
                                targetClass: 'field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                multipleFiles: true
                            },
                            isEdition: false,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),(_vm.hasAttachments)?_c('base-files',{attrs:{"settings":{
                            files: _vm.attachments,
                            templateId: parseInt( _vm.$route.params.id ),
                            teste: 'testevalue'
                        }},on:{"deleteFile":_vm.updateAttachments}}):_vm._e(),_c('div',{staticClass:"template-mail__description"},[_c('editor',{attrs:{"id":"body","name":"body","api-key":"z7h7b8lrk8hcmjia37ztugbuyx0f759bjbrkaknir3fu2l46","init":{
                                plugins: 'lists link image table help wordcount',
                                height: 500,
                                toolbar: 'undo redo | bold italic backcolor | alignleft aligncenter alignright alignjustify | \
                                    bullist outdent indent | table link image | subscript superscript'
                            }},model:{value:(_vm.body),callback:function ($$v) {_vm.body=$$v},expression:"body"}})],1)],1)]},proxy:true}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }